<template>
    <div
        class="flex-shrink-0 message-list-item-actions"
        :class="collapsible ? 'xl:hidden' : ''"
    >
        <div
            class="items-center space-x-1"
            :class="collapsible ? 'hidden xl:flex' : 'flex'"
        >
            <button
                class="bg-white border border-gray-darker text-sm px-2 py-1 rounded"
                @click.prevent="deliver"
            >
                <font-awesome-icon
                    :icon="['fas', 'paper-plane']"
                ></font-awesome-icon>
                <span :class="!collapsible ? 'hidden md:inline' : ''"
                    >Allow once</span
                >
            </button>
            <button
                class="bg-primary text-white text-sm px-2 py-1 rounded"
                @click.prevent="allow"
            >
                <font-awesome-icon
                    :icon="['far', 'thumbs-up']"
                ></font-awesome-icon>
                <span :class="!collapsible ? 'hidden md:inline' : ''"
                    >Allow</span
                >
            </button>
            <button
                class="bg-destructive text-white text-sm px-2 py-1 rounded"
                @click.prevent="deny"
            >
                <font-awesome-icon
                    :icon="['far', 'thumbs-down']"
                ></font-awesome-icon>
                <span :class="!collapsible ? 'hidden md:inline' : ''"
                    >Block</span
                >
            </button>
            <button
                class="bg-white border border-gray-darker text-sm px-2 py-1 rounded"
                @click.prevent="createAutomation"
                v-if="messages.length === 1"
            >
                <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
            </button>
        </div>
        <div
            class="relative"
            :class="collapsible ? 'block xl:hidden' : 'hidden'"
        >
            <button
                class="rounded-full overflow-hidden text-white bg-primary px-1"
                @click.prevent="toggle"
            >
                <font-awesome-icon
                    :icon="['fas', 'ellipsis-h']"
                ></font-awesome-icon>
            </button>
            <button
                v-if="isOpen"
                @click.prevent="toggle"
                tabindex="-1"
                class="fixed inset-0 h-full w-full cursor-default z-20"
            ></button>
            <div
                class="block absolute right-0 top-full border border-gray-dark py-2 w-48 bg-white rounded-lg shadow-xl z-30"
                :class="isOpen ? '' : 'hidden'"
            >
                <button
                    @click.prevent="allow"
                    class="block w-full text-left px-4 py-2 text-primary font-bold"
                >
                    <font-awesome-icon
                        :icon="['far', 'thumbs-up']"
                    ></font-awesome-icon>
                    Allow
                </button>
                <button
                    @click.prevent="deliver"
                    class="block w-full text-left px-4 py-2 text-primary font-bold"
                >
                    <font-awesome-icon
                        :icon="['fas', 'paper-plane']"
                    ></font-awesome-icon>
                    Allow once
                </button>
                <span class="border-b border-gray-dark block"></span>
                <button
                    @click.prevent="deny"
                    class="block w-full text-left px-4 py-2 text-destructive font-bold"
                >
                    <font-awesome-icon
                        :icon="['far', 'thumbs-down']"
                    ></font-awesome-icon>
                    Block
                </button>
                <span class="border-b border-gray-dark block"></span>
                <button
                    @click.prevent="createAutomation"
                    v-if="messages.length === 1"
                    class="block w-full text-left px-4 py-2 font-bold"
                >
                    <font-awesome-icon
                        :icon="['fas', 'cog']"
                    ></font-awesome-icon>
                    Automate
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import CreateNewAutomationModal from "../automation/CreateNewAutomationModal.vue";
import ActionOptionModal from "./ActionOptionModal";
import TutorialInspectActions from "./TutorialInspectActions";

export default {
    props: {
        collapsible: {
            type: Boolean,
            required: false,
            default: true,
        },
        messages: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            isOpen: false,
        };
    },
    methods: {
        closeHoverMenu() {
            this.isOpen = false;
        },
        toggle() {
            this.isOpen = !this.isOpen;
        },
        immediately() {
            return this.inspect("immediate");
        },
        deny() {
            return this.inspect("deny");
        },
        allow() {
            return this.inspect("allow");
        },
        denyWithOptions() {
            return this.inspectWithOptions("deny");
        },
        allowWithOptions() {
            return this.inspectWithOptions("allow");
        },
        deliver() {
            let ids = this.messages.map((m) => m.id);

            axios
                .post(`/api/messages/deliveries`, {
                    ids: ids,
                })
                .then((response) => {
                    this.$emit("inspected", {
                        ids: ids,
                        action: "once",
                    });
                })
                .catch((err) => console.error);
        },
        inspect(action, type, values, spell) {
            this.closeHoverMenu();

            if (
                !type &&
                !values &&
                !window.User.flags.tutorial_inspect_actions_shown
            ) {
                Modal.show(TutorialInspectActions).then(() => {
                    axios
                        .put("/api/me/flags", {
                            tutorial_inspect_actions_shown: true,
                        })
                        .then(() => {
                            window.User.flags.tutorial_inspect_actions_shown = true;
                        });
                });

                return;
            }

            // default to act on the address
            if (!type) type = "address";
            if (!values) values = this.messages.map((m) => m.from_address);

            this.loading = true;
            axios
                .post("/api/intents", {
                    type,
                    values,
                    action,
                    spell: spell === undefined ? null : spell,
                })
                .then(() => {
                    this.$emit("inspected", {
                        ids: this.messages.map((m) => m.id),
                        action: action,
                        type,
                    });
                })
                .catch((err) => console.error)
                .then(() => {
                    this.loading = false;
                });
        },
        inspectWithOptions(action) {
            this.closeHoverMenu();

            Modal.show(ActionOptionModal, {
                propsData: {
                    action: action,
                    messages: this.messages,
                },
            })
                .then((response) => {
                    this.inspect(
                        response.action,
                        response.type,
                        response.values
                    );
                })
                .catch(console.error);
        },
        createAutomation() {
            this.closeHoverMenu();
            Modal.show(CreateNewAutomationModal, {
                propsData: {
                    message: this.messages[0],
                },
            })
                .then((response) => {
                    this.$emit("inspected", {
                        ids: this.messages.map((m) => m.id),
                        action: response.action,
                        type: response.type,
                    });
                })
                .catch(console.error);
        },
    },
};
</script>

<style lang="scss">
.message-list-item {
    &:hover .message-list-item-actions {
        display: inline-block;
    }
}
</style>
